import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type P = {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void | Promise<void>;
};

export function VisitorBookingsRejectVisitDialog({ open, onClose, onConfirm }: Readonly<P>) {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) {
      setReason("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(reason.trim());
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="visitor-reject-visit-title"
      data-testid="visitor-bookings-reject-visit-dialog"
    >
      <DialogTitle id="visitor-reject-visit-title">
        {t("_visitorBookings_rejectVisitTitle")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {t("_visitorBookings_rejectVisitBody")}
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={1}
          label={t("_visitorBookings_rejectVisitReasonLabel")}
          placeholder={t("_visitorBookings_rejectVisitReasonPlaceholder")}
          value={reason}
          onChange={event => setReason(event.target.value)}
          slotProps={{
            htmlInput: { maxLength: 2000, "data-testid": "visitor-reject-visit-reason" }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid="visitor-reject-visit-cancel" color="secondary">
          {t("_visitorBookings_rejectVisitCancel")}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          data-testid="visitor-reject-visit-confirm"
        >
          {t("_visitorBookings_rejectVisitConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
